import { mapFirstImage } from '../DataTypes/imageMapper';
import { mapFirstPerson } from '../DataTypes/personMapper';
import { mapBasePageProperties } from './basePagePropertiesMapper';
import { formatDate } from '3-foundation/Localization/formatDate';
import logger from '3-foundation/Logging/logger';
interface Props extends Umbraco.BasePage {
	newsDate: string;
	newsHeading: string;
	newsTeaser: { markup: string };
	newsAuthor; // Todo: define type
	newsImage: Umbraco.Image[];
	newsImageAltText?: string;
}

export const mapNewsPageProperties = async (
	{ newsDate, newsHeading, newsTeaser, newsAuthor, newsImage, newsImageAltText, ...properties }: Props,
	pageId: string,
	siteId: string,
	locale: string,
): Promise<Content.NewsPageProperties> => {
	try {
		const basePageProperties = await mapBasePageProperties(properties, siteId, locale);
		basePageProperties.pageSections = basePageProperties?.pageSections?.map((pageSection) => {
			const section = pageSection as Content.ContentSection;
			section.settings.properties.width = section.settings?.properties?.width ? section.settings.properties.width : 'Small';
			return section;
		});

		return {
			...basePageProperties,
			newsDate: newsDate,
			newsDateDisplay: formatDate({ dateInput: newsDate, locale }),
			newsHeading,
			newsTeaser: newsTeaser?.markup ?? null,
			newsAuthor: mapFirstPerson(newsAuthor ?? []),
			newsImage: mapFirstImage(newsImage ?? []),
			newsImageAltText,
		};
	} catch (e) {
		logger.error('Could not map NewsPage Properties', e);
		throw new Error('Could not map NewsPage Properties', e);
	}
};
